import Auth from './auth/reducer';
import App from './app/reducer';
import Client from './module/client/reducer';
import Calendar from './calendar/reducer';

export default {
  Auth,
  App,
  Calendar,
  Client,
};
